import { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { FileZipOutlined, LoadingOutlined } from "@ant-design/icons";
import "../../../styles/fileItem.css";
import { List, Badge } from "antd";

interface FileItemProps {
  name: string;
  created: string;
  url: string;
  notificationDelivered: boolean;
}

const FileItem: React.FC<FileItemProps> = ({
  name,
  created,
  url,
  notificationDelivered,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post("/exports/download", {
        link: url,
      });
      if (response && response.data && response.data.data) {
        const downloadUrl = response.data.data.url;

        // Triggers download
        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const listItem = (
    <List.Item>
      {isLoading ? (
        <LoadingOutlined />
      ) : (
        <FileZipOutlined className="download-icon" />
      )}
      <List.Item.Meta
        title={
          <a onClick={handleDownload} href="#">
            {name}
          </a>
        }
        description={
          <span className="file-date">
            {new Date(created).toLocaleString("es-PA")}
          </span>
        }
      />
    </List.Item>
  );

  return notificationDelivered ? (
    listItem
  ) : (
    <Badge.Ribbon text="New">{listItem}</Badge.Ribbon>
  );
};

export default FileItem;
